export default {
  light: {
    // primary: "#536DFE",
    blue: '#536DFE',
    primary: "#FCB3C5",
    secondary: "#FF5C93",
    error: "#FF4081",
    warning: "#FFC260",
    success: "#4caf50",
    info: "#9013FE",
    textColor: "#B9B9B9",
    iconColor: "#FFFFFF",
    grayBold: '#4a4a4a',
    mPink: '#E5A3B3'
  }
};

